(function () {
  //-- 产品轮播图
  //----------------------------------------------
  function initThumb () {
    var thumbItems = $('.swiper-thumb').find('.swiper-slide')
    for (var i=0; i<thumbItems.length; i++) {
      thumbItems.eq(i).attr('data-index', i)
    }
  }
  function setThumbActive (activeIndex) {
    $('.swiper-thumb').find('.swiper-slide')
    .eq(activeIndex).addClass('swiper-slide-active')
    .siblings().removeClass('swiper-slide-active');
  }
  var swiperPreview = new Swiper(".swiper-preview", {
    spaceBetween: 15,
    lazy: {
      loadPrevNext: true,
    },
    on:{
      slideChange: function () {
        setThumbActive(this.activeIndex);
      },
    },
  });


  var swiperThumb = new Swiper(".swiper-thumb", {
    slidesPerView: 'auto',
    watchSlidesVisibility: true,
    on:{
      init: function (swiper){
        initThumb()
      },
      touchEnd: function(swiper,event){
        var currentIndex = event.target.parentNode.getAttribute("data-index");
        swiperPreview.slideTo(currentIndex);
        setThumbActive(currentIndex);
      },
    },
  });
  
  //-- 产品内容 Tab
  //----------------------------------------------
  $('.tab-header .item').on('click', function () {
    $(this).siblings().removeClass('is-active');
    $(this).addClass('is-active');
  
    const activeIndex = $(this).index();
    const tabBody = $(this).parent('.tab-header').next();
    tabBody.find('.content')
           .eq(activeIndex).addClass('is-show')
           .siblings().removeClass('is-show');
  })

  //-- 图片缩放
  //----------------------------------------------
  $('.img-zoom').each(function () {
    new Viewer($(this)[0], {
      url: 'data-src',
      navbar: false,
      maxZoomRatio: 3,
      title: false,
      loading: true,
      toolbar: {
        zoomIn:  1,
        zoomOut: 1
      }
    });
  })
})();